import { Slider, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'

const useStyles = makeStyles({
  slider: props => ({
    marginLeft: '9px',
    width: props.fullWidth ? '100%' : '100px',
    padding: props.padding || '8px 0 8px 10px',
    '& .MuiSlider-rail': {
      height: props.height ? `${props.height}px` : '2px',
      opacity: 1,
      borderRadius: '4px',
      background: 'var(--Gray-Lighter, #E5E7EB)',
    },
    '& .MuiSlider-track': {
      height: props.height ? `${props.height}px` : '2px',
      backgroundColor: props.color,
    },
    '& .MuiSlider-thumb': {
      width: props.thumbSize || 12,
      height: props.thumbSize || 12,
      backgroundColor: props.color,
      '&:hover': {
        boxShadow: `0 0 0 8px ${props.color}20`,
      },
      '&.Mui-focusVisible': {
        boxShadow: `0 0 0 12px ${props.color}30`,
      },
    },
  }),
})

const CoreSlider = ({
  initialValue = 100,
  onChange,
  height,
  color,
  thumbSize,
  padding,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  className,
  fullWidth = false,
  ...otherProps
}) => {
  const [value, setValue] = useState(initialValue)
  const classes = useStyles({ height, color, thumbSize, padding, fullWidth })

  const handleChange = (event, newValue) => {
    setValue(newValue)
    if (onChange) {
      onChange(newValue / 100)
    }
  }

  return (
    <Slider
      value={value}
      onChange={handleChange}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      className={`${classes.slider} ${className || ''}`}
      {...otherProps}
    />
  )
}

export default CoreSlider
